import { select } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import countries from '@swf/generated/countries.json';

import { getCountries } from '../Country/getCountries';
import type { Props as SelectProps } from '../Select/Select';
import Select from '../Select/Select';

import { TXTCLI_Country_of_Residence, TXTWCL_Find_my_country } from './CountrySelect.messages.json';
import Country from './components/Country/Country';

type Props = Partial<SelectProps>;

interface Component extends React.FC<React.PropsWithChildren<Props>> {
  Country: typeof Country;
}

export const findCountry = (lookupValue?: string) =>
  countries.find(({ value }: { value: string }) => value === lookupValue);

const CountrySelect: Component = ({ children, name = 'country', ...props }) => (
  <Select
    name={name}
    options={getCountries(useSelector(select.cms.getSiteId))}
    item={Country}
    title={TXTCLI_Country_of_Residence}
    searchLabel={TXTWCL_Find_my_country}
    {...props}
  >
    {children}
  </Select>
);

CountrySelect.Country = Country;

export default CountrySelect;
